import Vue from "vue";
import Vuex from "vuex";

// Todos os módulos que criar, adicionar aqui
import site from "./modules/site.module";
import application from "./modules/application.module";
import auth from "./modules/auth.module";
import user from "./modules/user.module";
import areaDeAtuacoes from "./modules/areaDeAtuacoes.module";
import tags from "./modules/tags.module";
import disciplinas from "./modules/disciplinas.module";
import fornecedores from "./modules/fornecedores.module";
import rents from "./modules/rents.module";
import dashboards from "./modules/dashboards.module";
import accessControls from "./modules/access.module";
import notifications from "./modules/notifications.module";
import pushers from "./modules/pushers.module";
import payments from "./modules/payments.module";
import relatorios from "./modules/relatorios.module";
import royalties from "./modules/royalties.module";
import documentos from "./modules/documentos.module";
import cursos from "./modules/cursos.module";
import acervos from "./modules/acervos.module";
import niveisAcessos from "./modules/niveisAcessos.module";

//Temporario
import solicitacoes from "./modules/solicitacoes.module";
import organizations from "./modules/organizations.module";
import usuarioAcesso from "./modules/usuarioAcesso.module";
import leads from "./modules/leads.module";

import areaTi from "./modules/areaTi";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    site,
    application,
    auth,
    user,
    tags,
    areaDeAtuacoes,
    disciplinas,
    fornecedores,
    rents,
    dashboards,
    accessControls,
    notifications,
    pushers,
    payments,
    relatorios,
    documentos,
    organizations,
    //Temporario
    solicitacoes,
    royalties,
    cursos,
    acervos,
    niveisAcessos,
    usuarioAcesso,
    areaTi,
    leads
  }
});
